import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { FilterFields, FormField } from '../../../dashboard/admin/report/report';
import { AuthService } from '../../services/auth.service';
import { FormValidatorService } from '../../services/form-validator.service';

@Component({
  selector: 'app-report-filter',
  templateUrl: './report-filter.component.html',
  styleUrls: ['./report-filter.component.scss']
})
export class ReportFilterComponent implements OnInit {
  @Input() filterOpened!: BehaviorSubject<boolean>;
  @Input() hasDateRanges: boolean = false;
  @Input() singleDates: boolean = false;
  @Input() filterFields: FilterFields[] = [];
  @Output() filterTriggered = new EventEmitter();
  @Output() assignedBusinessesChanged = new EventEmitter<boolean>();
  checked: boolean = false;

  public form!: FormGroup;
  public formValidator = new FormValidatorService();
  public ranges: any = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment()
        .subtract(1, "month")
        .startOf("month"),
      moment()
        .subtract(1, "month")
        .endOf("month")
    ]
  };

  constructor(private auth:AuthService) { }

  async ngOnInit(){
    this.checked = (await this.auth.getRole()).name.includes('SuperAdmin') ? false :true;
    this.buildForm();
  }

  private buildForm() {
    this.form = this.formValidator.createForm(
      this.generateFormCreationObject()
    );
    //console.log(this.form);
  }

  private generateFormCreationObject() {
    const output = [] as FormField[];
    if (this.hasDateRanges) {
      output.push({
        fieldName: "createdAt",
        defaultValue: null
      });
    }
    if (this.filterFields && this.filterFields.length) {
      for (const f of this.filterFields) {
        output.push({
          fieldName: f.filterFieldName,
          defaultValue: f.defaultValue || null,
          validators: f.validators
        });
      }
    }

    return output;
  }

  public filter() {
    const o = removeEmpty(this.form.value);
    if (o.createdAt && !Object.keys(o.createdAt).length) {
      delete o.createdAt;
    }
    if (this.form.valid) {
      this.filterTriggered.emit(o);
    }
  }

  checkboxChange(value){
    this.assignedBusinessesChanged.emit(value.checked)
  }
  onOptionSelected(event : {option:{key:string,value:string},fieldName:string}) {
    const { option, fieldName } = event;
    this.form.controls[fieldName].setValue(option.value);
  }
}

const removeEmpty = (obj: any) => {
  const o = JSON.parse(JSON.stringify(obj)); // Clone source oect.

  Object.keys(o).forEach(key => {
    if (o[key] && typeof o[key] === "object") {
      if (Object.keys(o[key]).length) {
        o[key] = removeEmpty(o[key]); // Recurse.
      } else {
        o[key] = undefined;
      }
    } else if (o[key] === undefined || o[key] === null || o[key] === "null") {
      delete o[key]; // Delete undefined and null.
    } else {
      o[key] = o[key]; // Copy value.
    }
  });

  return o; // Return new object.
};
